const proxyMetricsUrl = {
  postback: 'postback'
}

export default (api) => ({
  postback: (data) => {
    const type = localStorage.getItem(data.type);

    if (type) return

    localStorage.setItem(data.type, data.type)
    const formattedType = data.type.replaceAll(' ', '_')
    api.get(proxyMetricsUrl.postback, {
      params: {
        clickid: data.click_id,
        sum: data.sum,
        type: formattedType
      }
    })
  }
})
